"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXTENDED_FIELD_TYPES = void 0;
var EXTENDED_FIELD_TYPES = exports.EXTENDED_FIELD_TYPES = ['TEXT', 'NUMBER', 'INTEGER', 'FILE', 'DATE', 'DATETIME', 'REGEX', 'CATALOG'];